'use client'

import { useEffect, useState } from 'react'

/** Tailwind `md` — the web app's shell collapses its sidebar below it. */
export const DEFAULT_MOBILE_BREAKPOINT = 768

/**
 * True below `breakpoint` px. The pre-mount value is `false`: the sidebar
 * renders its desktop layout on the server and collapses only once the
 * viewport is measured (the contract both apps' shells were built on).
 *
 * The web app passes nothing (768, `md`); the admin app's 12-column grid
 * hides the rail below `lg`, so its `SidebarProvider` passes 1024 and the
 * mobile sheet takes over on tablets.
 */
export function useIsMobile(breakpoint = DEFAULT_MOBILE_BREAKPOINT): boolean {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const query = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    setIsMobile(query.matches)

    function onChange(event: MediaQueryListEvent) {
      setIsMobile(event.matches)
    }

    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [breakpoint])

  return isMobile
}
